<div class="d-flex align-items-center justify-content-end text-primary text-end h-100">
  <span class="fw-bold text-primary">{{ pointsBalance$ | async | FortressCurrencyPipe: 'PTS' }}</span>
</div>
